import { render } from "./SelectionDatagridBodyTypeRow.vue?vue&type=template&id=4cc47958"
import script from "./SelectionDatagridBodyTypeRow.vue?vue&type=script&lang=js"
export * from "./SelectionDatagridBodyTypeRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__